import React from 'react';
import { Section, Carousel, TeslaText as Text, ModelDetailCard, OnVisible } from 'components';

import * as styles from './styles.module.scss';

const ModelComparisonCarousel = (props) => {
  const { data } = props;
  const { primary, items } = data;

  const { title, description } = primary;

  // content checks
  const titleHtml = title?.html;
  const descriptionHtml = description?.html;

  return (
    <Section sliceName="ModelComparisonCarousel" className={styles.section} containerClassName={styles.container}>
      <header className={styles.header}>
        {titleHtml && <Text className={styles.title} {...title} />}
        {descriptionHtml && <Text className={styles.description} {...description} />}
      </header>

      {items?.[0] && (
        <OnVisible visibleClassName={styles.visible} className={styles.carousel}>
          <Carousel
            settings={{
              dots: false,
              arrows: true,
              cssEase: 'ease',
              centerMode: true,
              centerPadding: '0',
              slidesToShow: 3,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    arrows: false,
                    centerPadding: '20px',
                    slidesToShow: 2.1,
                  },
                },
                {
                  breakpoint: 659,
                  settings: {
                    arrows: false,
                    centerPadding: '0',
                    slidesToShow: 1,
                  },
                },
              ],
            }}
          >
            {items.map((card, index) => {
              return <ModelDetailCard key={`model-comparison-carousel-card-${index}`} data={card} variant="tesla" />;
            })}
          </Carousel>
        </OnVisible>
      )}
    </Section>
  );
};

export default ModelComparisonCarousel;
